import React, { useState, useEffect } from 'react';
import AdminHome from './AdminHome';
import { IoCloseSharp } from "react-icons/io5";
import { BsMenuButtonWideFill } from "react-icons/bs";
const AdminAddRentForm = () => {
  const [categoryType, setCategoryType] = useState('');
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [styles, setStyles] = useState([]);
  const [styleName, setStyleName] = useState('');
  const [isCategoryEnabled, setIsCategoryEnabled] = useState(false);

  useEffect(() => {
    fetch('/api/categories')
      .then((response) => response.json())
      .then((data) => setCategories(data))
      .catch((error) => console.error('Error fetching categories:', error));

    fetch('/api/styles')
      .then((response) => response.json())
      .then((data) => setStyles(data))
      .catch((error) => console.error('Error fetching styles:', error));
  }, []);

  const handleCategoryTypeChange = (event) => {
    setCategoryType(event.target.value);
    setSelectedCategories([]);
    setStyleName('');
    setIsCategoryEnabled(false);
  };

  const handleStyleNameChange = (event) => {
    setStyleName(event.target.value);
    setIsCategoryEnabled(event.target.value.trim() !== '');
  };

  const handleCategoryToggle = (category) => {
    setSelectedCategories((prev) => {
      const categoryExists = prev.some(item => item.categoryId === category.categoryId);
      
      if (categoryExists) {
        return prev.filter(item => item.categoryId !== category.categoryId);
      } else {
        return [...prev, {
          categoryId: category.categoryId,
          categoryName: category.categoryName
        }];
      }
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      const formData = {
        categoryType,
        styleName,
        selectedCategories, // Now sending array of objects with both id and name
      };

      console.log('Sending data:', formData); // For debugging

      const response = await fetch('/api/save-category', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      setCategoryType('')
      setStyleName('')
      

      if (response.ok) {
        alert('Categories saved successfully!');
        setCategoryType('');
        setStyleName('');
        setSelectedCategories([]);  // Reset selected categories
        setIsCategoryEnabled(false); // Disable category selection
      } else {
        throw new Error('Failed to save categories');
      }
    } catch (error) {
      console.error('Error saving category:', error);
      alert('Error saving categories');
    }
  };

  return (
<>
<div className="tf-page-title">
            <div className="container-full">
                <div className="heading text-center">Add SubModules</div>
            </div>
        </div>
        <section className="flat-spacing-11">
            <div className="container">
                    <div className="row">
                      <AdminHome/>
    <div className="category-form col-lg-9">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Rent By:</label>
          <select value={categoryType} onChange={handleCategoryTypeChange}>
            <option value="">Select Rent Type</option>
            {styles.map((style) => (
              <option key={style._id} value={style.styleName}>
                {style.styleName}
              </option>
            ))}
          </select>
        </div>

        {categoryType && (
          <div className="form-group">
            <label>Style Name:</label>
            <input
              type="text"
              value={styleName}
              onChange={handleStyleNameChange}
              placeholder="Enter style name"
            />
          </div>
        )}

        {isCategoryEnabled && (
          <div className="form-group">
            <label>Select Categories:</label>
            <div className="checkbox-grid">
              {categories.map((category) => (
                <div key={category.categoryId} className="checkbox-item">
                  <input
                    type="checkbox"
                    id={`category-${category.categoryId}`}
                    checked={selectedCategories.some(item => item.categoryId === category.categoryId)}
                    onChange={() => handleCategoryToggle(category)}
                  />
                  <label htmlFor={`category-${category.categoryId}`}>
                    {category.categoryName}
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="form-group">
          <h3>Selected Categories:</h3>
          <div className="selected-tags">
            {selectedCategories.length === 0 ? (
              <span className="no-categories">No categories selected</span>
            ) : (
              selectedCategories.map((category) => (
                <span key={category.categoryId} className="category-tag">
                  {category.categoryName}
                  <button 
                    type="button"
                    className="remove-tag"
                    onClick={() => handleCategoryToggle(category)}
                  >
                    ×
                  </button>
                </span>
              ))
            )}
          </div>
        </div>

        <button type="submit" className="submit-button">
          Save Categories
        </button>
      </form>

      <style jsx>{`
        .category-form {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .form-group {
          margin-bottom: 20px;
        }

        label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: #333;
        }

        select, input {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
        }

        select:focus, input:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
        }

        .checkbox-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 12px;
          margin-top: 10px;
        }

        .checkbox-item {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .checkbox-item input[type="checkbox"] {
          width: auto;
          margin-right: 8px;
        }

        .checkbox-item label {
          margin: 0;
          font-weight: normal;
          cursor: pointer;
        }

        .selected-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 10px;
        }

        .category-tag {
          background:rgb(29, 158, 31);
          color:#ffffff;
          padding: 6px 12px;
          border-radius: 16px;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .remove-tag {
          background: none;
          border: none;
          color: #1976d2;
          font-size: 18px;
          cursor: pointer;
          padding: 0 2px;
          line-height: 1;
        }

        .remove-tag:hover {
          color: #ff4444;
        }

        .no-categories {
          color: #666;
          font-style: italic;
        }

        .submit-button {
          width: 100%;
          padding: 12px;
          background:rgb(30, 93, 36);
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .submit-button:hover {
          background: #0056b3;
        }

        h3 {
          margin: 0 0 10px 0;
          font-size: 16px;
          color: #333;
        }
      `}</style>
    </div>
    </div>
    </div>



            <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                <div className="canvas-wrapper">
                    <header className="canvas-header">
                        <span className="title">SIDEBAR ACCOUNT</span>
                     
                       <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                    </header>
                    <div className="canvas-body sidebar-mobile-append"> </div>
                </div>
            </div>
    </section>
    
      <div className="btn-sidebar-account">
                                  <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                                      <BsMenuButtonWideFill />
                                  </button>
                              </div>
                  
                              <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                                  <div className="canvas-wrapper">
                                      <header className="canvas-header">
                                          <span className="title">SIDEBAR ACCOUNT</span>
                                          {/* <SideNavbaBarDashboard /> */}
                                          <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                                      </header>
                                      
                                      <div className="canvas-body sidebar-mobile-append"> </div>
                                  </div>
                              </div>

    </>
  );
};

export default AdminAddRentForm;